import React from 'react';
import { fmtTotals, fmtMyt, muted, primary, ORIGIN_CLS } from './mbApi';

const Stat = ({ label, value, target, note, testid }) => (
  <div className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-3" data-testid={testid}>
    <p className={`text-xs uppercase tracking-wide ${muted}`}>{label}</p>
    <p className={`text-lg font-semibold ${primary}`}>{value}</p>
    {target && <p className={`text-xs ${muted}`}>Target: {target}</p>}
    {note && <p className={`text-xs ${muted}`}>{note}</p>}
  </div>
);

const myr = (v) => (v != null ? `RM ${v.toFixed(2)}` : 'N/A');

export const StatsRow = ({ dash }) => {
  if (!dash) return null;
  const a = dash.actual;
  const sync = dash.sync || {};
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="mb-dashboard">
        <Stat label="Creative unik menerima delivery" value={a.unique_creatives_delivering} target="20-30 pool aktif"
          note={`${dash.delivery_window_days} hari · Aktif di Meta ${a.unique_creatives_meta_active ?? 'N/A'} · Running di CRM ${a.unique_creatives_active}`} testid="mb-stat-creatives" />
        <Stat label="Ads Running dipadankan" value={a.ads_mapped_active} note={`${a.tests_unmatched} ujian belum padan Ad ID`} testid="mb-stat-ads" />
        <Stat label="Amount spent hari ini (separa)" value={fmtTotals(a.spend_today)} note="Ikut currency asal iklan" testid="mb-stat-spend" />
        <Stat label="CPS semua join — hari ini (separa)" value={myr(a.cps_myr)} target="RM5-RM8 (ceiling RM8)"
          note={`Spend MYR ÷ semua join melalui link (termasuk rejoin) = ${a.joins_known_source} join${a.cps_note ? ` · ${a.cps_note}` : ''}`} testid="mb-stat-cps" />
        <Stat label="CPS join unik — hari ini (separa)" value={myr(a.cps_first_myr)}
          note={`Spend MYR ÷ join unik pertama = ${a.joins_first_today} · rejoin ${a.joins_rejoin_today} · tanpa sumber ${a.joins_unknown_today}`} testid="mb-stat-cps-first" />
        <Stat label="Client close" value={a.client_close ?? 'N/A'} target="15-20 sehari" note="N/A bukan sifar — definisi close belum disahkan" testid="mb-stat-close" />
      </div>
      <p className={`text-xs ${muted}`} data-testid="mb-provenance">
        {dash.provenance && <>Asal data: <span className={ORIGIN_CLS[dash.provenance.origin]}>{dash.provenance.label}</span> · </>}
        Hari ikut MYT (Asia/Kuala_Lumpur) · Auto-sync: <span className={primary}>{sync.auto ? 'ON' : 'OFF'}</span>
        {' · '}Last sync berjaya: <span className={primary}>{fmtMyt(sync.last_sync_at)}</span>
        {sync.status === 'separa' && <span className="text-amber-400"> · sync separa</span>}
        {dash.provenance?.origin === 'unknown' && ' — rekod tanpa bukti sync Meta/Telegram; jangan guna untuk keputusan operasi'}
        {dash.provenance && (dash.provenance.excluded.metrics_other_source + dash.provenance.excluded.joins_other_source) > 0 &&
          ` · ${dash.provenance.excluded.metrics_other_source + dash.provenance.excluded.joins_other_source} rekod dari sumber lain TAK dicampur dalam totals`}
      </p>
      {sync.stale && <p className="text-xs text-amber-400" data-testid="mb-stale-warning">Data lapuk — last sync lebih 24 jam lepas.</p>}
    </div>
  );
};
